import { pause, unpause, is_paused } from './ajax-helpers.js';

var page,
	existingPosts,
	lastPage;

function getPosts(nextPage) {
	var nextPageNum,
		nextPagePath;

	if (existingPosts.length < 1 || existingPosts.length < 1) {
		return;
	}

	if (is_paused(existingPosts) || (nextPage === true && lastPage === true)) {
		return;
	}

	pause(existingPosts);

	nextPageNum = page + 1;

	nextPagePath = window.location.pathname + '?news-events-page=' + nextPageNum;

	$.ajax(nextPagePath, {
		method: 'GET',
		dataType: 'html',
		success: function (pageContent) {

			var htmlDoc,
				newListing,
				newPosts;

			htmlDoc = $((new DOMParser()).parseFromString(pageContent, "text/html"));
			newListing = htmlDoc.find('[data-js="news-posts"]');
			newPosts = newListing.find('[data-js="news-post"]');
			console.log(newPosts);

			if (newListing.data('last-page') == true) {
				lastPage = true;

				$('[data-js="show-more-row"]').hide();
			}

			if (newPosts.length > 0) {
				existingPosts.append(newPosts);
			}

			eval(htmlDoc.find('#php-datalayer-events').html());

			page = nextPageNum;

			unpause(existingPosts);
		},
		error: function () {
			unpause(existingPosts);
		}
	});
}

function initCommunityNewsPagination() {

	page = 1;
	existingPosts =$('[data-js="news-posts"]');
	lastPage = existingPosts.data('last-page');

	$('body').on('click', '[data-js="show-more"]', function () {
		if (!lastPage) {
			getPosts(true);
		}

		return false;
	});
}

export { initCommunityNewsPagination };
